import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeUserNameSelector, makeShortUserNameSelector } from "~/store/selectors/selector.users.jsx";
import Angie from "~/utils/angie.jsx";
import SimpleLink from "../SimpleLink.jsx";
import SimpleText from "../SimpleText.jsx";

const UserNameContainer = ({ userId, shortName, linkName, className }) => {
  const getShortUserName = useMemo(makeShortUserNameSelector, []);
  const getUserName = useMemo(makeUserNameSelector, []);
  const link = `${Angie.root_url}/users/${userId}`;
  const shortUserName = useSelector((state) => getShortUserName(state, userId));
  const fullUserName = useSelector((state) => getUserName(state, userId));
  const children = shortName ? shortUserName : fullUserName;

  if (!userId) return null;

  return linkName ? (
    <SimpleLink
      link={link}
      className={className}
    >
      {children}
    </SimpleLink>
  ) : (
    <SimpleText className={className}>{children}</SimpleText>
  );
};

UserNameContainer.propTypes = {
  userId: PropTypes.number,
  linkName: PropTypes.bool,
  className: PropTypes.string,
  shortName: PropTypes.bool,
};

UserNameContainer.defaultProps = {
  linkName: false,
  shortName: false,
};

UserNameContainer.displayName = `UserNameContainer`;

export default UserNameContainer;
